export default {
  namespaced: true,
  state: {

  },
  mutations: {

  },
  actions: {
    verifyMobileNumber(context,{mobile,mobilecountry,via}){
      return this.$http.patch('/person/mobile',{mobilecountry, mobile, via}).then((response)=>{
        return response;
      }).catch((err)=>{
        throw err.response;
      });
    },
    verifyEmail(context,{email}){
      return this.$http.patch('/person/email',{email}).then((response)=>{
        return response;
      }).catch((err)=>{
        throw err.response;
      });
    },
    verifyOtpForLogin({dispatch,commit},{otp}){
      return this.$http.post('/person/verify',{otp}).then((response)=>{
        if(!response.data.assessment){
          throw new Error('no_assessments');
        }else{
          commit('assessment/setAssessment',response.data.assessment,{root:true});
          dispatch('speedtest/start',null,{root:true});
        }
        return response.data;
      }).catch((err)=>{
        if(!err.response){
          throw err;
        }else{
          throw err.response.data;
        }
      });
    },
    updateInfo({commit},person){
      return this.$http.patch('/person',person).then((response)=>{
        const person=response.data.data;
        commit('assessment/setPerson',person,{root:true});
        return response.data;
      }).catch((err)=>{
        throw err.response.data;
      });
    }
  },
  getters: {}
}